export default __webpack_public_path__ + "static/media/POPPINS-BLACKITALIC.9703707d.TTF";